export const OrderState = {
  CANCEL: 0, // 已取消
  NEW: 10, // 已产生但未支付
  PAY: 20, // 已支付待接单
  RECEIPT: 23, // 已接單待派单
  OCCUPY: 24, // 已派單待到店
  DELIVER: 26, // 已到店待取貨
  SEND: 30, // 已取貨派送中
  SUCCESS: 40 // 已收货
}

export const ErrandOrderType = {
  BUY: 0, // 幫我買
  SEND: 1 // 幫我送
}

export const OrderBillState = {
  PENDING: 0, //待騎士確認
  DISTRIBUTOR_CONFIRMED: 1, //騎士確認，待平台確認
  COMPANY_CONFIRMED: 2, //平台確認，待付款
  PAYMENT_CONFIRMED: 3, //已付款
}

// 回報商品操作
export const OrderGoodsRevisedRecordAction = {
	SOLD_OUT: 0,
	MODIFY_GOODS_PRICE: 1
}

// 回報商品狀態
export const OrderGoodsRevisedRecordStatus = {
	PENDING: 0,
	ACCEPTED: 1,
	REJECTED: -1
}
